<template>
  <div>
    <section class="container">
      <div class="section-group">
        <div class="row">
          <div class="col-lg-3">
            <UserFeedInfoVue props_selectItem="group"></UserFeedInfoVue>
          </div>
          <div class="col-lg-9">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-12">
                    <ul class="nav nav-pills">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_haveGroup',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_haveGroup' })
                          "
                          > {{ $t('Social.group.index.feedGroup_haveGroup') }}<span class="count">{{ count }}</span></a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_groupSetting',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_groupSetting' })
                          "
                          > {{ $t('Social.group.index.feedGroup_groupSetting') }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_groupList',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_groupList' })
                          "
                          > {{ $t('Social.group.index.feedGroup_groupList') }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_userblacklist',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_userblacklist' })
                          "
                          > {{ $t('Social.group.index.feedGroup_userblacklist') }}
                        </a>
                      </li>
                      <!-- <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_groupAddAcc',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_groupAddAcc' })
                          "
                          >添加好友/群</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_groupAccList',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_groupAccList' })
                          "
                          >好友列表</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{
                            active: $route.name === 'feedGroup_groupBlackList',
                          }"
                          @click.prevent="
                            $router.push({ name: 'feedGroup_groupBlackList' })
                          "
                          >黑名單</a
                        >
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <!-- feed group -->
                <div class="my-profile section-group">
                  <div class="row">
                    <div class="col-12 pt-4">
                      <router-view></router-view>
                    </div>
                  </div>
                </div>
                <!-- /.feed group -->
                <!-- 頁碼 -->
                <div class="row my-5">
                  <div class="col-12"></div>
                </div>
                <!-- /.頁碼 -->
              </div>
              <!-- /.card-body -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UserFeedInfoVue from "@/components/Social/UserFeedInfo.vue";
export default {
  components: {
    UserFeedInfoVue,
  },
  data() {
    return {
      count: 0,
    };
  },
  created() {
    this.GetMyGroupList();
  },
  mounted() {
    this.$bus.$on("refreshCount", (n) => {
      this.count = n;
    });
  },
  methods: {
    GetMyGroupList() {
      this.$api.social
        .GetMyGroupList({
          SkipCount: 0,
          MaxResultCount: 999,
        })
        .then((res) => {
          this.count = res.data.result.totalCount;
        });
    },
  },
};
</script>

<style scoped>
.nav-item:hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/group/index.vue